import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 8v8","key":"svg-0"}],["path",{"d":"M20 16v-8","key":"svg-1"}],["path",{"d":"M8 4h8","key":"svg-2"}],["path",{"d":"M8 20h8","key":"svg-3"}]]

/**
 * IconBorderSides
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYm9yZGVyLXNpZGVzIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik00IDh2OCIgLz4KICA8cGF0aCBkPSJNMjAgMTZ2LTgiIC8+CiAgPHBhdGggZD0iTTggNGg4IiAvPgogIDxwYXRoIGQ9Ik04IDIwaDgiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/border-sides
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBorderSides = createReactComponent('outline', 'border-sides', 'BorderSides', __iconNode);

export default IconBorderSides;